import React, { Component } from 'react';

export class NotFound extends Component {
    render() {
        return <div>
            <p>Ресурс не найден</p>
        </div>;
    }
}